import { render, staticRenderFns } from "./ErpButton.vue?vue&type=template&id=53e2fd3d&"
import script from "./ErpButton.vue?vue&type=script&lang=js&"
export * from "./ErpButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports